import createIcon from '../../createIcon';

/**
 * @component @name AccountBox
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTkgM0g1QzMuOSAzIDMgMy45IDMgNVYxOUMzIDIwLjEgMy45IDIxIDUgMjFIMTlDMjAuMSAyMSAyMSAyMC4xIDIxIDE5VjVDMjEgMy45IDIwLjEgMyAxOSAzWk0xMiA2QzEzLjkzIDYgMTUuNSA3LjU3IDE1LjUgOS41QzE1LjUgMTEuNDMgMTMuOTMgMTMgMTIgMTNDMTAuMDcgMTMgOC41IDExLjQzIDguNSA5LjVDOC41IDcuNTcgMTAuMDcgNiAxMiA2Wk0xOSAxOUg1VjE4Ljc3QzUgMTguMTUgNS4yOCAxNy41NyA1Ljc2IDE3LjE5QzcuNDcgMTUuODIgOS42NCAxNSAxMiAxNUMxNC4zNiAxNSAxNi41MyAxNS44MiAxOC4yNCAxNy4xOUMxOC43MiAxNy41NyAxOSAxOC4xNiAxOSAxOC43N1YxOVoiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const AccountBox = createIcon('AccountBox', [
  [
    'path',
    {
      d: 'M19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3ZM12 6C13.93 6 15.5 7.57 15.5 9.5C15.5 11.43 13.93 13 12 13C10.07 13 8.5 11.43 8.5 9.5C8.5 7.57 10.07 6 12 6ZM19 19H5V18.77C5 18.15 5.28 17.57 5.76 17.19C7.47 15.82 9.64 15 12 15C14.36 15 16.53 15.82 18.24 17.19C18.72 17.57 19 18.16 19 18.77V19Z',
      key: '1xdtcz',
    },
  ],
]);

export default AccountBox;
